import axios from 'axios';

const API_URL = 'https://backend-railway-production-1582.up.railway.app/api/auth/';

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'signin', {
        cedula: user.cedula,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      nombre : user.nombre,
      apellido : user.apellido,
      cedula: user.cedula,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();
